import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import styles from './Section.css';

type SectionProps = {
  children: Array<ReactNode> | ReactNode;
  /**
   * @default white
   */
  bgc?: 'white' | 'gray';
};

export const Section: FC<SectionProps> = props => {
  const { children, bgc = 'white' } = props;

  return (
    <section className={clsx(styles['container'], styles[`container-bgc-${bgc}`])}>
      <div className={styles['inner']}>{children}</div>
    </section>
  );
};
